import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { ForgotPassword as ForgotPasswordComponent } from '@smorder/core';
import validateEmail from '../../util/validate-email';
import { NavigationLink } from '../../components';

import config from '../../../run-config';

const ForgotPassword = ({ match, ...props }) => {
  const successMatch = useRouteMatch(`${match.path}/success`) || {};
  const login = <NavigationLink to="/login">Zurück zum Login</NavigationLink>;

  return (
    <ForgotPasswordComponent
      {...props}
      logo={config.loginLogo}
      validateEmail={validateEmail}
      login={login}
      onErrorNotification={() => {}}
      success={!!successMatch.isExact}
    />
  );
};

ForgotPassword.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ForgotPassword;
